import { h } from 'preact';

import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';
import ListItemText from '@mui/material/ListItemText';

import ArrowBack from '@mui/icons-material/ArrowBack';

import styles from '../../components/global.css';
import LazyPercentileChart from '../../components/percentileChart/lazyPercentileChart.jsx';
import { UrlTable } from './_common.jsx';
import LazyInpUrlRecord from '../../components/inpUrlRecord/lazyInpUrlRecord.jsx';
import LazyVariations from '../../components/variations/lazyVariations.jsx';
import { PharosLink } from '../../components/router/router.jsx';

export default function LazyInpIssueDetail(props) {
  const { propertyId } = props;

  return (
    <>
      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Typography variant="h5">
          <PharosLink href={propertyId ? `/property/${propertyId}/lcp` : ''}>
            <Button color="secondary">
              <ArrowBack className={styles.reportAnchor} />
            </Button>
          </PharosLink>
          <Skeleton
            variant="text"
            width={200}
            height={36}
            sx={{ display: 'inline-block' }}
          />
        </Typography>
        <Grid container>
          <Grid item xs={12} md={4}>
            <ListItemText
              primary={<Skeleton width={120} />}
              secondary={<Skeleton width={60} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListItemText
              primary={<Skeleton width={120} />}
              secondary={<Skeleton width={60} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListItemText
              primary={<Skeleton width={120} />}
              secondary={<Skeleton width={60} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListItemText
              primary={<Skeleton width={120} />}
              secondary={<Skeleton width={60} />}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <ListItemText
              primary={<Skeleton width={120} />}
              secondary={<Skeleton width={60} />}
            />
          </Grid>
        </Grid>
      </Paper>

      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Paper className={`${styles.originArea} ${styles.lcpPercentile}`}>
          <Typography variant="h6">Value</Typography>
          <LazyPercentileChart />
        </Paper>
      </Paper>

      <Paper className={`${styles.originArea} ${styles.issueTimings}`}>
        <Typography variant="h5">Detailed timings</Typography>

        <Paper className={`${styles.originArea} ${styles.lcpPercentile}`}>
          <Typography variant="h6">TTFB</Typography>
          <LazyPercentileChart />
        </Paper>
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <Typography variant="h5">Variations</Typography>
        <LazyVariations />
      </Paper>

      <Paper className={`${styles.originArea}`}>
        <div className={styles.urlListHeader}>
          <Typography variant="h5">Affected Urls</Typography>
        </div>
        <UrlTable>
          {Array(30)
            .fill(null)
            .map((_, index) => (
              <LazyInpUrlRecord key={index} />
            ))}
        </UrlTable>
      </Paper>
    </>
  );
}
